module.exports = __webpack_public_path__ + "static/media/YF57_0.62d28922.jpg";